import{KibScroll}from"./kib-scroll";export default KibScroll;